import axiosInstance from '@/api/axios.js'
import Pusher from 'pusher-js/dist/web/pusher.min.js'

// The reload re-reads the same browser cache, so a chunk that is broken rather than
// stale fails again and this loops forever. Retry once per tab.
window.addEventListener('vite:preloadError', () => {
    if (sessionStorage.getItem('vite:preloadRetried')) return
    sessionStorage.setItem('vite:preloadRetried', '1')
    window.location.reload()
})

window.Pusher = Pusher

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axiosInstance
